/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'svg'>

export const Checkmark: React.FC<Props> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 12 8" height="1em" {...props}>
		<path d="M9.96.2 4.1 6.05 2.04 3.97a.6.6 0 0 0-.88 0 .6.6 0 0 0 0 .88l2.51 2.52a.6.6 0 0 0 .44.19c.2 0 .32-.07.44-.2l6.29-6.28a.6.6 0 0 0 0-.88.6.6 0 0 0-.88 0Z" />
	</svg>
)
